import $ from "jquery";
import { areas } from "../framework/areas";
import { countryState } from "./countryState";
import { regions } from "../framework/regions";
import { programs } from "../framework/programs";
import { editions } from "../framework/courseEdition";

let sortColumn;
let sortColumnIndex;
let sortOrder;
let peopleSearchFilters;
let personTable; //putting this here so I have a reference. Otherwise calling Datatable() seems to recreate it?

function init() {
    sortColumn = "";
    sortColumnIndex = 0;
    sortOrder = false;
}

function doSetup() {
    return $.Deferred(function(def) {
        const regionPromise = populateRegions();
        const areaPromise = populateAreas();
        const programPromise = populatePrograms();
        const editionPromise = populateEditions();
        const countryPromise = countryState.populateCountriesSelect("#searchCountrySelect", "#searchNaStateSelection");

        $.when(regionPromise, areaPromise, countryPromise, programPromise, editionPromise).then(function() {
            //
            // Load SearchFilters initially from sessionStorage and set the fields
            // If there weren't any filters in session then create new one
            // Do it after all the selects have been populated
            //
            if (typeof (Storage) !== "undefined" && sessionStorage.getItem("peopleSearchFilters") !== null) {
                peopleSearchFilters = JSON.parse(sessionStorage.getItem("peopleSearchFilters"));
            } else {
                setFilters();
            }
            setFieldsToFilter(peopleSearchFilters);
            setEvents();
            filterAreasBySelectedRegion();
            def.resolve();
        });
    });
}

function populateRegions() {
    return regions.getRegions().done(function (results) {
        const selectList = $("#searchRegionSelect");
        selectList.find("option").not(":first").remove();
        for (let i = 0; i < results.length; i++) {
            $("#searchRegionSelect")
                .append("<option value='" + results[i].id + "'>" + results[i].regionNumber + "</option>");
        }
    });
}

function populateAreas() {
    areas.getAreas().done(function(results) {
        const selectList = $("#searchRegionAreaSelect");
        selectList.find("option").not(":first").remove();
        for (let i = 0; i < results.length; i++) {
            let name = results[i].name;
            name = name.replace("(assigned)", "");
            $("#searchRegionAreaSelect").append("<option data-region='" + results[i].regionId + "' value='" + results[i].id + "'>" + name + "</option>");
        }
    });
}

function populatePrograms() {
    return programs.getPrograms().done(function (results) {
        const selectList = $("#searchProgramSelect");
        selectList.find("option").not(":first").remove();
        for (let i = 0; i < results.length; i++) {
            $("#searchProgramSelect")
                .append("<option value='" + results[i].id + "'>" + results[i].name + "</option>");
        }
    });
}

function populateEditions() {
    editions.getCourseEditions().done(function (results) {
        const selectList = $("#searchProgramEditionSelect");
        selectList.find("option").not(":first").remove();
        for (let i = 0; i < results.length; i++) {
            let name = results[i].name;
            $("#searchProgramEditionSelect").append("<option value='" + results[i].id + "'>" + name + "</option>");
        }
    });
}

function filterAreasBySelectedRegion() {
    const selectedRegionId = $("#searchRegionSelect").val();

    if (selectedRegionId === "") {
        $("#searchRegionAreaSelect option").show();
    } else {
        $("#searchRegionAreaSelect option").not(":first").hide();
        $("#searchRegionAreaSelect option[data-region='" + selectedRegionId + "']").show();
    }
}

function setEvents() {
    $("#searchCountrySelect").change(function() {
        const selectedCountry = $(this).val();
        countryState.populateStatesSelect("#searchNaStateSelection", "#searchNonNaState", selectedCountry);
    });

    $("#searchRegionSelect").change(function() {
        filterAreasBySelectedRegion();
    });
}

function setFilters() {
    const searchFilter = {
        keyword: $("#searchKeyword").val(),
        active: $("#searchActive").is(":checked"),
        inActive: $("#searchInActive").is(":checked"),
        expired: $("#searchExpired").is(":checked"),
        roleIds: [],
        tagIds: [],
        areaIds: [],
        programId: $("#searchProgramSelect").val(),
        courseEditionIds: [],
        countryId: $("#searchCountrySelect").find("option:selected").attr("countryId"),
        countryValue: $("#searchCountrySelect").val(),
        stateId: $("#searchStateSelect").val(),
        stateText: $("#searchNonNaStateInput").val(),
        regionId: $("#searchRegionSelect").find("option:selected").val(),
        regionAreaId: $("#searchRegionAreaSelect").find("option:selected").val(),
        currentPage: 1,
        sortColumn: sortColumn,
        sortColumnIndex: sortColumnIndex,
        desc: sortOrder
    };

    $("[areaId]:checkbox:checked").each(function() {
        searchFilter.areaIds.push($(this).attr("areaId"));
    });

    const roles = $("#AddPersonRoleSelect2").val();
    searchFilter.roleIds = roles;
    const courseEdition = $("#searchProgramEditionSelect").val();

    if (courseEdition) {
        searchFilter.courseEditionIds.push(courseEdition);
    }

    $("[tagId]:checked").each(function() {
        searchFilter.tagIds.push($(this).attr("tagId"));
    });
    if (typeof (Storage) !== "undefined") {
        sessionStorage.setItem("peopleSearchFilters", JSON.stringify(searchFilter));
    }

    peopleSearchFilters = searchFilter;
    putFilterInStorage();

    return peopleSearchFilters;
}

function setFieldsToFilter() {
    $("#searchKeyword").val(peopleSearchFilters.keyword);
    $("#searchActive").prop("checked", peopleSearchFilters.active);
    $("#searchInActive").prop("checked", peopleSearchFilters.inActive);
    $("#searchExpired").prop("checked", peopleSearchFilters.expired);
    peopleSearchFilters.roleIds.forEach(function(id) {
        $("input[roleId='" + id + "']").prop("checked", true);
    });

    $("#AddPersonRoleSelect2").val(peopleSearchFilters.roleIds);
    $("#AddPersonRoleSelect2").selectpicker("refresh");

    peopleSearchFilters.tagIds.forEach(function(id) {
        $("input[tagId='" + id + "']").prop("checked", true);
    });
    peopleSearchFilters.areaIds.forEach(function(id) {
        $("input[areaId='" + id + "']").prop("checked", true);
    });
    $("#searchCountrySelect").val(peopleSearchFilters.countryValue);
    countryState.populateStatesSelect("#searchNaStateSelection", "#searchNonNaState", peopleSearchFilters.countryValue);
    $("#searchStateSelect").val(peopleSearchFilters.stateId);
    $("#searchNonNaStateInput").val(peopleSearchFilters.stateText);
    $("#searchRegionSelect").val(peopleSearchFilters.regionId);
    $("#searchRegionAreaSelect").val(peopleSearchFilters.regionAreaId);

    const edition = peopleSearchFilters.courseEditionIds[0];
    $("#searchProgramEditionSelect").val(edition);

    $("#searchProgramSelect").val(peopleSearchFilters.programId);

    const sortColumn = peopleSearchFilters.sortColumn;
    const sortColumnIndex = peopleSearchFilters.sortColumnIndex;
    const sortOrder = peopleSearchFilters.desc;
    setSortOrder(sortColumn, sortColumnIndex, sortOrder);
}

function setSortOrder(sortColumn, sortColumnIndex, sortOrder) {
    if (sortColumn !== "undefined" && sortColumn !== "") {
        return;
    }
    if (typeof personTable === "undefined") {
        return;
    }
    if (sortColumn !== null && sortColumnIndex > 0) {
        if (sortOrder) {
            personTable.columns[sortColumnIndex].addClass("sorting_desc");
        } else {
            personTable.columns[sortColumnIndex].addClass("sorting_asc");
        }
    }
}

function getFilters() {
    if (peopleSearchFilters === "undefined") {
        peopleSearchFilters = setFilters();
    }
    return peopleSearchFilters;
}

function getQueryStringFilters() {
    const filters = setFilters();
    for (const key in filters) {
        if (!filters[key]) {
            delete filters[key];
        }
    }
    return filters;
}

function clearFilters() {
    $("#searchKeyword").val("");
    $("#searchFilters :input").each(function () {
        switch (this.type) {
            case "text":
                $("#searchKeyword, #searchNonNaStateInput").val("");
                break;
            case "textarea":
                $(this).val("");
                break;
            case "checkbox":
                if (this.disabled !== true)
                    $(this).prop("checked", false);
                $("#searchActive").prop("checked", true);
                $("#searchExpired").prop("checked", true);
                break;
            case "radio":
                this.checked = false;
                break;
        }
    });

    $("#AddPersonRoleSelect2").val("default");
    $("#AddPersonRoleSelect2").selectpicker("refresh");

    $("#searchRegionSelect, #searchRegionAreaSelect, #searchCountrySelect, #searchStateSelect, #searchProgramEditionSelect, #searchProgramSelect").find("option:selected").prop("selected", false);
    $("#searchStateSelect")
        .find("option")
        .remove()
        .end()
        .append("<option value=\"\">State/Province</option>");
    regions.getRegions().done(populateRegions, populateAreas);
    $("#searchRegionSelect, #searchRegionAreaSelect").val("");
    $("#regionsAreaDiv").show();

    setFilters();
    putFilterInStorage();
}

function setSort(paramSortColumn, paramSortColumnIndex, paramSortOrder) {
    sortColumn = paramSortColumn;
    sortColumnIndex = paramSortColumnIndex;
    sortOrder = paramSortOrder;
    setFilters();
    putFilterInStorage();
}

function setPersonTable(parampersontable) {
    personTable = parampersontable;
}

function putFilterInStorage() {
    if (typeof (Storage) !== "undefined") {
        sessionStorage.setItem("peopleSearchFilters", JSON.stringify(peopleSearchFilters));
    }
}

export const peopleDashboardFilters = {
    init: init,
    getFilters: getFilters,
    setFilters: setFilters,
    clearFilters: clearFilters,
    getQueryStringFilters: getQueryStringFilters,
    setSort: setSort,
    setPersonTable: setPersonTable,
    doSetup: doSetup
};